import catchAsync from "../../utils/catchAsync";
import http from "./http";

export const getServiceNonKeyApi = catchAsync(async (values) => {
    const data = await http.get(
        `/settings/list?currentPage=1&limit=100`
    );

    return data;
});